export enum ReferralConversionStage {
  initial,
  signup,
  trial,
  subscribe,
}
